import { useState } from "react";
import { days_of_the_week } from "../../../consts/misc";
import useToggle from "../../../hooks/useToggle";
import {
  getCurrentDay,
  getCurrentMonth,
  getCurrentWeek,
  getDayIndex,
} from "../../../utils/getMethods";
import "../styles/typography.css";

const HeaderRow = (props: any) => {
  const currentWeek = getCurrentWeek(props.weekStart, props.weekEnd);
  const monthMatch =
    getCurrentMonth(currentWeek[0]).number ===
    getCurrentMonth(currentWeek[6]).number;

  const monthInscription = () => {
    if (monthMatch) {
      return getCurrentMonth(currentWeek[0]).word.slice(0, 3);
    } else if (
      getCurrentMonth(currentWeek[0]).number <
      getCurrentMonth(currentWeek[6]).number
    ) {
      return (
        getCurrentMonth(currentWeek[0]).word.slice(0, 3) +
        "/" +
        getCurrentMonth(currentWeek[6]).word.slice(0, 3)
      );
    } else
      return (
        getCurrentMonth(currentWeek[6]).word.slice(0, 3) +
        "/" +
        getCurrentMonth(currentWeek[0]).word.slice(0, 3)
      );
  };

  const days = currentWeek.map((date, key) => {
    const index = getDayIndex(date.getDay());
    const day = days_of_the_week[index!];
    const dayNumber = date.getDate();
    const today = new Date();
    const highlightedCondition =
      getCurrentDay(today).word === day &&
      dayNumber === today.getDate() &&
      today.getMonth() === date.getMonth();
    return (
      <span key={key} className="header-Cell">
        <div
          id={`${day}`}
          className={`dayRef ${highlightedCondition && "highlited"}`}
          style={{
            fontSize: props.dayRef_fontSize || "14px",
            color: highlightedCondition ? "white" : "",
          }}
        >
          <p className="dayRef-text" style={{ fontSize: "10px" }}>
            {day.slice(0, 3)}
          </p>
          <p className="dayRef-text" style={{ fontSize: "14px" }}>
            {dayNumber}
          </p>
        </div>
      </span>
    );
  });

  return (
    <div
      className="header-row"
      /* style={{ maxHeight: `calc(${props.height}/100 * 14)` }} */
    >
      <p
        className="monthRef"
        style={{ fontSize: props.monthRef_fontSize || "13px" }}
      >
        {monthInscription()}
      </p>
      {days}
    </div>
  );
};
export default HeaderRow;
